export { default as GDMConditionalRender } from './GDMConditionalRender';

export type {
  GDMConditionalRenderProps,
  GDMConditionalRenderPropsComponent,
} from './GDMConditionalRender.type';
